import React, {
  useState,
  useEffect,
  useReducer,
  useContext,
  useRef,
  useCallback,
} from "react";
import * as XLSX from "xlsx";

import { toast } from "react-toastify";
import { useParams, useHistory } from "react-router-dom";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";

import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import BlockIcon from "@material-ui/icons/Block";
import Avatar from "@material-ui/core/Avatar";
import Tooltip from "@material-ui/core/Tooltip";
import Checkbox from "@material-ui/core/Checkbox";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";

import { FormattedPhoneNumber } from "../../utils/formatSerializedId";

import api from "../../services/api";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactListItemModal from "../../components/ContactListItemModal";
import ContactListItemFromContactsModal from "../../components/ContactListItemFromContactsModal";
import ConfirmationModal from "../../components/ConfirmationModal/";

import { i18n } from "../../translate/i18n";
import PageBase from "../../components/PageBase";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../../components/Can";
import useContactLists from "../../hooks/useContactLists";
import { TablePagination } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import planilhaExemplo from "../../assets/planilha.xlsx";
import ForbiddenPage from "../../components/ForbiddenPage";
import ColorModeContext from "../../layout/themeContext";
import { createGradientStyles } from "../../utils/themeColors";
// import { SocketContext } from "../../context/Socket/SocketContext";


const reducer = (state, action) => {
  if (action.type === "LOAD_CONTACTS") {
    const contacts = action.payload;
    const newContacts = [];

    contacts.forEach((contact) => {
      const contactIndex = state.findIndex((c) => c.id === contact.id);
      if (contactIndex !== -1) {
        state[contactIndex] = contact;
      } else {
        newContacts.push(contact);
      }
    });

    return [...state, ...newContacts];
  }

  if (action.type === "UPDATE_CONTACTS") {
    const contact = action.payload;
    const contactIndex = state.findIndex((c) => c.id === contact.id);

    if (contactIndex !== -1) {
      state[contactIndex] = contact;
      return [...state];
    } else {
      return [contact, ...state];
    }
  }

  if (action.type === "DELETE_CONTACT") {
    const contactId = action.payload;

    const contactIndex = state.findIndex((c) => c.id === contactId);
    if (contactIndex !== -1) {
      state.splice(contactIndex, 1);
    }
    return [...state];
  }

  if (action.type === "BULK_DELETE_CONTACTS") {
    const contactIds = action.payload;
    return state.filter(contact => !contactIds.includes(contact.id));
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  avatarCell: {
    width: 56,
    padding: theme.spacing(0.5, 1),
  },
  avatar: {
    width: 36,
    height: 36,
    fontSize: '0.85rem',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#fff',
    fontWeight: 600,
  },
  validIcon: {
    color: 'green',
    fontSize: 20,
  },
  invalidIcon: {
    color: '#bbb',
    fontSize: 20,
  },
  importDialogPaper: {
    borderRadius: 14,
    overflow: "hidden",
    width: "60vw !important",
    maxWidth: "780px !important",
    minWidth: 360,
    [theme.breakpoints.down("sm")]: {
      width: "92vw !important",
      minWidth: "auto",
      maxWidth: "92vw !important",
    },
  },
  importDialogTitle: {
    padding: theme.spacing(2, 3),
    "& .MuiTypography-root": {
      fontWeight: 600,
      fontSize: "1.2rem",
    },
  },
  ...createGradientStyles(theme),
  importDialogContent: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.type === "dark" ? theme.palette.background.default : "#fafafa",
  },
  importDialogActions: {
    padding: theme.spacing(2, 3),
    backgroundColor: theme.palette.type === "dark" ? theme.palette.background.default : "#f5f5f5",
    borderTop: theme.palette.type === "dark" ? "1px solid #444" : "1px solid #e0e0e0",
  },
  progressBarTrack: {
    width: "100%",
    height: 12,
    borderRadius: 999,
    overflow: "hidden",
    background: theme.palette.type === "dark" ? "#2d2d2d" : "#e5e7eb",
  },
  progressBarFill: {
    height: "100%",
    background: "linear-gradient(90deg, #1d4ed8 0%, #2563eb 100%)",
    transition: "width 200ms ease",
  },
  statsCard: {
    padding: theme.spacing(1.25, 1.5),
    borderRadius: 10,
    border: `1px solid ${theme.palette.type === "dark" ? "#444" : "#e5e7eb"}`,
    background: theme.palette.type === "dark" ? "#1f1f1f" : "#fff",
    fontWeight: 500,
  },
  statsAction: {
    border: "none",
    background: "transparent",
    padding: 0,
    fontWeight: 600,
    fontSize: "inherit",
    textAlign: "left",
  },
  detailsBox: {
    marginTop: theme.spacing(1.5),
    maxHeight: 180,
    overflowY: "auto",
    padding: theme.spacing(1.25, 1.5),
    borderRadius: 10,
    border: `1px solid ${theme.palette.type === "dark" ? "#444" : "#e5e7eb"}`,
    background: theme.palette.type === "dark" ? "#1f1f1f" : "#fff",
  },
}));

const ContactListItems = () => {
  const classes = useStyles();
  const theme = useTheme();
  const colorModeContext = useContext(ColorModeContext);
  const useGradient = colorModeContext?.useGradient || theme.palette?.gradient || false;

  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const { contactListId } = useParams();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const [searchParam, setSearchParam] = useState("");
  const [contacts, dispatch] = useReducer(reducer, []);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [contactListItemModalOpen, setContactListItemModalOpen] =
    useState(false);
  const [deletingContact, setDeletingContact] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [contactList, setContactList] = useState({});
  const [fromContactsModalOpen, setFromContactsModalOpen] = useState(false);
  const fileUploadRef = useRef(null);

  // Estados para exclusão em lote
  const [selectedContactIds, setSelectedContactIds] = useState([]);
  const [allContactsSelected, setAllContactsSelected] = useState(false);
  const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState(false);
  const [isDeletingSelected, setIsDeletingSelected] = useState(false);
  const [reloadToken, setReloadToken] = useState(0);
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [showDuplicatedList, setShowDuplicatedList] = useState(false);
  const [showExistingList, setShowExistingList] = useState(false);
  const [showErrorList, setShowErrorList] = useState(false);
  const [importProgress, setImportProgress] = useState({
    total: 0,
    totalRows: 0,
    totalContacts: 0,
    toImport: 0,
    imported: 0,
    existing: 0,
    duplicatedInsideSpreadsheet: 0,
    duplicatedContactsPreview: [],
    existingContactsPreview: [],
    errorContactsPreview: [],
    errors: 0,
    processed: 0,
    percent: 0,
    status: "",
    completed: false,
    hasError: false,
  });

  const buildDuplicatePreviewFromRows = (rows = []) => {
    const normalize = (value) => String(value || "").replace(/\D/g, "");
    const normalizeEmail = (value) => String(value || "").trim().toLowerCase();
    const seen = new Set();
    const duplicates = [];

    rows.forEach((row) => {
      const name = String(row.nome || row.Nome || "").trim();
      const number = normalize(
        row.numero || row.número || row.Numero || row.Número || row.telefone || row.Telefone || ""
      );
      const email = normalizeEmail(row.email || row["e-mail"] || row.Email || row["E-mail"] || "");
      const key = number || email;

      if (!key) return;

      if (seen.has(key)) {
        if (duplicates.length < 50) {
          duplicates.push({ name, number, email });
        }
      } else {
        seen.add(key);
      }
    });

    return duplicates;
  };

  const { findById: findContactList } = useContactLists();

  useEffect(() => {
    findContactList(contactListId).then((data) => {
      setContactList(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactListId]);

  useEffect(() => {
    setPageNumber(1);
    setSelectedContactIds([]);
    setAllContactsSelected(false);
  }, [searchParam, pageSize]);

  const fetchContacts = useCallback(async () => {
    setLoading(true);
    try {
      dispatch({ type: "RESET" });
      const { data } = await api.get(`contact-list-items`, {
        params: { searchParam, pageNumber, pageSize, limit: pageSize, contactListId },
      });
      dispatch({ type: "LOAD_CONTACTS", payload: data.contacts });
      setHasMore(data.hasMore);
      setTotalCount(data.count || data.contacts?.length || 0);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  }, [searchParam, pageNumber, pageSize, contactListId]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [fetchContacts, reloadToken]);

  useEffect(() => {
    const companyId = user.companyId;
    // const socket = socketManager.GetSocket();

    const onCompanyContactLists = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_CONTACTS", payload: data.record });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_CONTACT", payload: +data.id });
      }

      if (data.action === "bulk-delete") {
        if (Number(data.contactListId) === Number(contactListId)) {
          setSelectedContactIds([]);
          setAllContactsSelected(false);
          setReloadToken(prev => prev + 1);
        }
      }

      if (data.action === "reload") {
        dispatch({ type: "LOAD_CONTACTS", payload: data.records });
      }
    }
    socket.on(`company-${companyId}-ContactListItem`, onCompanyContactLists);

    return () => {
      socket.off(`company-${companyId}-ContactListItem`, onCompanyContactLists);
    };
  }, [contactListId]);

  useEffect(() => {
    const companyId = user.companyId;
    const importEventName = `company-${companyId}-ContactListItem-${+contactListId}`;

    const updateImportProgress = (stage, summary = {}) => {
      const total = summary.total || summary.totalContacts || 0;
      const processed = summary.processed || 0;
      const calculatedPercent = total > 0
        ? Math.min(100, Math.round((processed / total) * 100))
        : 0;
      const percent = typeof summary.percent === "number"
        ? Math.min(100, Math.max(0, summary.percent))
        : calculatedPercent;

      let status = "Processando importação...";
      if (stage === "parsing") status = "Lendo planilha...";
      if (stage === "saving") status = "Importando contatos...";
      if (stage === "done") status = "Importação finalizada.";

      setImportProgress(prev => ({
        ...prev,
        ...summary,
        percent: stage === "done" ? 100 : percent,
        status,
        completed: stage === "done",
        hasError: false,
      }));
      setImportModalOpen(true);
    };

    const onContactListImportEvent = (data) => {
      if (data?.action === "import-progress") {
        updateImportProgress(data.stage, data.summary);
      }

    };

    socket.on(importEventName, onContactListImportEvent);

    return () => {
      socket.off(importEventName, onContactListImportEvent);
    };
  }, [socket, user.companyId, contactListId]);

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleOpenContactListItemModal = () => {
    setSelectedContactId(null);
    setContactListItemModalOpen(true);
  };

  const handleCloseContactListItemModal = () => {
    setSelectedContactId(null);
    setContactListItemModalOpen(false);
  };

  const hadleEditContact = (contactId) => {
    setSelectedContactId(contactId);
    setContactListItemModalOpen(true);
  };

  const handleDeleteContact = async (contactId) => {
    try {
      await api.delete(`/contact-list-items/${contactId}`);
      toast.success(i18n.t("contacts.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
    setSearchParam("");
    setPageNumber(1);
  };

  const handleSelectContact = (contactId) => {
    const newSelected = new Set(selectedContactIds);
    if (newSelected.has(contactId)) {
      newSelected.delete(contactId);
    } else {
      newSelected.add(contactId);
    }
    setAllContactsSelected(false);
    setSelectedContactIds(Array.from(newSelected));
  };

  const handleSelectAllCurrentPage = () => {
    const currentIds = contacts.map((c) => c.id);
    const allSelected = currentIds.length > 0 && currentIds.every((id) => selectedContactIds.includes(id));

    if (allSelected) {
      setSelectedContactIds([]);
      setAllContactsSelected(false);
    } else {
      setSelectedContactIds(currentIds);
      setAllContactsSelected(false);
    }
  };

  const handleSelectAllListContacts = () => {
    setAllContactsSelected(true);
  };

  const handleClearSelection = () => {
    setSelectedContactIds([]);
    setAllContactsSelected(false);
  };

  const handleBulkDelete = async () => {
    if (!allContactsSelected && selectedContactIds.length === 0) return;
    setIsDeletingSelected(true);
    try {
      if (allContactsSelected) {
        const payload = {
          all: true,
          contactListId: Number(contactListId)
        };
        console.log("[CONTACT_LIST_DELETE_SELECTED_FRONTEND]", {
          all: allContactsSelected,
          totalSelected: selectedContactIds.length,
          contactListId,
          payload
        });
        await api.delete(`/contact-lists/${contactListId}/contacts/bulk-delete`, {
          data: payload
        });
        toast.success(i18n.t("contactListItems.toasts.bulkDeleted", { count: totalCount }));
      } else {
        const payload = {
          all: false,
          contactListId: Number(contactListId),
          contactIds: selectedContactIds
        };
        console.log("[CONTACT_LIST_DELETE_SELECTED_FRONTEND]", {
          all: allContactsSelected,
          totalSelected: selectedContactIds.length,
          contactListId,
          payload
        });
        await api.delete(`/contact-lists/${contactListId}/contacts/bulk-delete`, {
          data: payload
        });
        toast.success(i18n.t("contactListItems.toasts.bulkDeleted", { count: selectedContactIds.length }));
      }

      setSelectedContactIds([]);
      setAllContactsSelected(false);

      if (pageNumber > 1 && contacts.length === selectedContactIds.length && !allContactsSelected) {
        setPageNumber(pageNumber - 1);
      } else {
        await fetchContacts();
      }
    } catch (err) {
      toastError(err?.response?.data?.message || i18n.t("contactListItems.toasts.bulkDeleteError"));
    } finally {
      setIsDeletingSelected(false);
      setDeleteConfirmModalOpen(false);
    }
  };

  const handleImportContacts = async () => {
    try {
      setConfirmOpen(false);
      setImportModalOpen(true);
      setShowDuplicatedList(false);
      setShowExistingList(false);
      setShowErrorList(false);
      setImportProgress(prev => ({
        ...prev,
        toImport: 0,
        imported: 0,
        existing: 0,
        errors: 0,
        processed: 0,
        percent: 0,
        status: "Enviando arquivo...",
        completed: false,
        hasError: false,
      }));
      const formData = new FormData();
      formData.append("file", fileUploadRef.current.files[0]);
      const { data } = await api.request({
        url: `contact-lists/${contactListId}/upload`,
        method: "POST",
        data: formData
      });

      const summary = data?.summary || {};
      setImportProgress(prev => ({
        ...prev,
        ...summary,
        duplicatedInsideSpreadsheet:
          typeof summary.duplicatedInsideSpreadsheet === "number"
            ? summary.duplicatedInsideSpreadsheet
            : (prev.duplicatedInsideSpreadsheet || 0),
        duplicatedContactsPreview:
          Array.isArray(summary.duplicatedContactsPreview) && summary.duplicatedContactsPreview.length > 0
            ? summary.duplicatedContactsPreview
            : (prev.duplicatedContactsPreview || []),
        percent: typeof summary.percent === "number"
          ? summary.percent
          : (summary.total > 0
            ? Math.round(((summary.processed || 0) / summary.total) * 100)
            : 100),
        status: "Importação concluída.",
        completed: true,
        hasError: false,
      }));
      setShowDuplicatedList(false);
      setShowExistingList(false);
      setShowErrorList(false);
      setReloadToken(prev => prev + 1);
    } catch (err) {
      toastError(err);
      setImportProgress(prev => ({
        ...prev,
        status: "Erro ao importar contatos.",
        completed: true,
        hasError: true,
      }));
      setImportModalOpen(true);
    }
  };

  const handleFileSelected = async (event) => {
    const selectedFile = event?.target?.files?.[0];
    if (!selectedFile) return;

    try {
      setImportModalOpen(true);
      setShowDuplicatedList(false);
      setShowExistingList(false);
      setShowErrorList(false);
      setImportProgress(prev => ({
        ...prev,
        totalRows: 0,
        total: 0,
        totalContacts: 0,
        toImport: 0,
        imported: 0,
        existing: 0,
        duplicatedInsideSpreadsheet: 0,
        duplicatedContactsPreview: [],
        existingContactsPreview: [],
        errorContactsPreview: [],
        errors: 0,
        processed: 0,
        percent: 0,
        status: "Lendo planilha...",
        completed: false,
        hasError: false,
      }));

      const arrayBuffer = await selectedFile.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(worksheet, {
        header: 0,
        raw: false,
        defval: ""
      }) || [];

      const validRows = rows.filter((row) => {
        const number = String(
          row.numero || row.número || row.Numero || row.Número || row.telefone || row.Telefone || ""
        ).replace(/\D/g, "");
        return number.length > 0;
      });
      const duplicatedContactsPreview = buildDuplicatePreviewFromRows(rows);

      setImportProgress(prev => ({
        ...prev,
        totalRows: rows.length,
        total: validRows.length,
        totalContacts: validRows.length,
        toImport: validRows.length,
        duplicatedContactsPreview,
        status: "Planilha carregada. Pronto para importar.",
      }));
      setConfirmOpen(true);
    } catch (error) {
      toastError(error);
      setImportProgress(prev => ({
        ...prev,
        status: "Não foi possível ler a planilha.",
        completed: true,
        hasError: true,
      }));
    }
  };

  const handleChangePage = (event, newPage) => {
    setPageNumber(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setPageNumber(1);
  };

  const goToContactLists = () => {
    history.push("/contact-lists");
  };

  const isAllSelected = contacts.length > 0 && contacts.every((c) => selectedContactIds.includes(c.id));
  const isIndeterminate = selectedContactIds.length > 0 && !isAllSelected;
  const selectedCount = allContactsSelected ? totalCount : selectedContactIds.length;
  const isCurrentPageFullySelected = contacts.length > 0 && contacts.every((c) => selectedContactIds.includes(c.id));

  return (
    <PageBase
      className="contact-list-items-page app-page-root"
      title={contactList.name}
      actions={
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          <TextField
            placeholder={i18n.t("contactListItems.searchPlaceholder")}
            type="search"
            value={searchParam}
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "gray" }} />
                </InputAdornment>
              ),
            }}
          />
          {(allContactsSelected || selectedContactIds.length > 0) ? (
            <Button
              variant="contained"
              color="secondary"
              startIcon={<DeleteSweepIcon />}
              onClick={() => setDeleteConfirmModalOpen(true)}
              disabled={isDeletingSelected}
            >
              {isDeletingSelected ? "Excluindo..." : `Excluir Selecionados (${selectedCount})`}
            </Button>
          ) : (
            <>
              <Button variant="contained" color="primary" onClick={goToContactLists}>
                {i18n.t("contactListItems.buttons.lists")}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  fileUploadRef.current.value = null;
                  fileUploadRef.current.click();
                }}
              >
                {i18n.t("contactListItems.buttons.import")}
              </Button>
              <Button variant="contained" color="primary" onClick={() => setFromContactsModalOpen(true)}>
                Da agenda
              </Button>
              <Button variant="contained" color="primary" onClick={handleOpenContactListItemModal}>
                {i18n.t("contactListItems.buttons.add")}
              </Button>
            </>
          )}
        </div>
      }
      containerProps={{ className: classes.mainPaper }}
      footer={
        <TablePagination
          component="div"
          count={totalCount}
          page={Math.max(0, pageNumber - 1)}
          onPageChange={handleChangePage}
          rowsPerPage={pageSize}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 20, 50, 100]}
          labelRowsPerPage="Itens por página"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
          }
        />
      }
    >
      <ContactListItemModal
        open={contactListItemModalOpen}
        onClose={handleCloseContactListItemModal}
        aria-labelledby="form-dialog-title"
        contactId={selectedContactId}
      ></ContactListItemModal>
      <ContactListItemFromContactsModal
        open={fromContactsModalOpen}
        onClose={() => setFromContactsModalOpen(false)}
      />
      <ConfirmationModal
        title={
          deletingContact
            ? `${i18n.t("contactListItems.confirmationModal.deleteTitle")} ${deletingContact.name
            }?`
            : `${i18n.t("contactListItems.confirmationModal.importTitlte")}`
        }
        open={confirmOpen}
        onClose={setConfirmOpen}
        onConfirm={deletingContact ? () => handleDeleteContact(deletingContact.id) : handleImportContacts}
      >
        {deletingContact ? (
          `${i18n.t("contactListItems.confirmationModal.deleteMessage")}`
        ) : (
          <>
            {i18n.t("contactListItems.confirmationModal.importMessage")}
            <a href={planilhaExemplo} download="planilha.xlsx">
              {i18n.t("contactListItems.confirmationModal.downloadExample")}
            </a>
          </>
        )}
      </ConfirmationModal>
      <ConfirmationModal
        title={i18n.t("contactListItems.confirmationModal.deleteSelectedTitle", { count: selectedCount })}
        open={deleteConfirmModalOpen}
        onClose={() => setDeleteConfirmModalOpen(false)}
        onConfirm={handleBulkDelete}
      >
        {i18n.t("contactListItems.confirmationModal.deleteSelectedMessage")}
      </ConfirmationModal>
      {user.profile === "user" && user?.showCampaign === "disabled" ? (
        <ForbiddenPage />
      ) : (
            <div className="page-table-wrapper app-table-zebra">
              <>
                <input
                  style={{ display: "none" }}
                  id="upload"
                  name="file"
                  type="file"
                  accept=".xls,.xlsx"
                  onChange={handleFileSelected}
                  ref={fileUploadRef}
                />
              </>
              {isCurrentPageFullySelected && !allContactsSelected && totalCount > contacts.length && (
                <div className="bulk-selection-banner">
                  {i18n.t("contactListItems.bulk.pageSelected", { count: contacts.length })}
                  <button type="button" onClick={handleSelectAllListContacts}>
                    {i18n.t("contactListItems.bulk.selectAllList", { count: totalCount })}
                  </button>
                </div>
              )}
              {allContactsSelected && (
                <div className="bulk-selection-banner">
                  {i18n.t("contactListItems.bulk.allSelected", { count: totalCount })}
                  <button type="button" onClick={handleClearSelection}>
                    {i18n.t("contactListItems.bulk.clearSelection")}
                  </button>
                </div>
              )}
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        indeterminate={isIndeterminate}
                        checked={isAllSelected}
                        onChange={handleSelectAllCurrentPage}
                      />
                    </TableCell>
                    <TableCell align="center" style={{ width: 56 }}>
                      {i18n.t("common.statusLabel")}
                    </TableCell>
                    <TableCell align="center" style={{ width: 56 }}>
                      {i18n.t("contactListItems.table.photo")}
                    </TableCell>
                    <TableCell>{i18n.t("contactListItems.table.name")}</TableCell>
                    <TableCell align="center">
                      {i18n.t("contactListItems.table.number")}
                    </TableCell>
                    <TableCell align="center">
                      {i18n.t("contactListItems.table.email")}
                    </TableCell>
                    <TableCell align="center">
                      {i18n.t("contactListItems.table.actions")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <>
                    {contacts.map((contact) => {
                      const initials = contact.name
                        ? contact.name.split(" ").slice(0, 2).map(n => n[0]).join("").toUpperCase()
                        : "?";
                      return (
                        <TableRow key={contact.id} selected={selectedContactIds.includes(contact.id)}>
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={selectedContactIds.includes(contact.id)}
                              onChange={() => handleSelectContact(contact.id)}
                            />
                          </TableCell>
                          {/* Status: WhatsApp válido */}
                          <TableCell align="center" style={{ width: 56 }}>
                            <Tooltip title={contact.isWhatsappValid ? i18n.t("contactListItems.tooltips.whatsappValid") : i18n.t("contactListItems.tooltips.whatsappInvalid")}>
                              {contact.isWhatsappValid ? (
                                <CheckCircleIcon className={classes.validIcon} />
                              ) : (
                                <BlockIcon className={classes.invalidIcon} />
                              )}
                            </Tooltip>
                          </TableCell>
                          {/* Avatar */}
                          <TableCell align="center" className={classes.avatarCell}>
                            <Avatar
                              src={contact.profilePicUrl || contact.urlPicture}
                              className={classes.avatar}
                            >
                              {!contact.profilePicUrl && !contact.urlPicture && initials}
                            </Avatar>
                          </TableCell>
                          <TableCell>{contact.name}</TableCell>
                          <TableCell align="center">
                            {contact.number
                              ? <FormattedPhoneNumber serializedId={contact.number} />
                              : "-"}
                          </TableCell>
                          <TableCell align="center">{contact.email}</TableCell>
                          <TableCell align="center">
                          <IconButton
                            size="small"
                            onClick={() => hadleEditContact(contact.id)}
                          >
                            <EditIcon />
                          </IconButton>
                          <Can
                            role={user.profile}
                            perform="contacts-page:deleteContact"
                            yes={() => (
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setConfirmOpen(true);
                                  setDeletingContact(contact);
                                }}
                              >
                                <DeleteOutlineIcon />
                              </IconButton>
                            )}
                          />
                        </TableCell>
                        </TableRow>
                      );
                    })}
                    {loading && <TableRowSkeleton columns={6} />}
                  </>
                </TableBody>
              </Table>
            </div>
      )}
      <Dialog
        open={importModalOpen}
        onClose={importProgress.completed ? () => setImportModalOpen(false) : undefined}
        aria-labelledby="contact-import-progress-title"
        maxWidth={false}
        PaperProps={{
          className: classes.importDialogPaper,
          style: { width: "48vw", maxWidth: 640, minWidth: 340 }
        }}
      >
        <DialogTitle
          id="contact-import-progress-title"
          className={`${classes.importDialogTitle} ${useGradient ? classes.gradientBackground : classes.solidBackground}`}
        >
          {i18n.t("contactListItems.importProgress.importing", { percent: importProgress.percent })}
        </DialogTitle>
        <DialogContent dividers className={classes.importDialogContent}>
          <div className={classes.progressBarTrack}>
            <div className={classes.progressBarFill} style={{ width: `${importProgress.percent}%` }} />
          </div>

          <Grid container spacing={1} style={{ marginTop: 12 }}>
            <Grid item xs={12} sm={6}><Paper className={classes.statsCard}>{i18n.t("contactListItems.importProgress.total", { count: importProgress.total })}</Paper></Grid>
            <Grid item xs={12} sm={6}><Paper className={classes.statsCard}>{i18n.t("contactListItems.importProgress.toImport", { count: importProgress.toImport })}</Paper></Grid>
            <Grid item xs={12} sm={6}><Paper className={classes.statsCard}>{i18n.t("contactListItems.importProgress.processed", { count: importProgress.processed })}</Paper></Grid>
            <Grid item xs={12} sm={6}><Paper className={classes.statsCard}>{i18n.t("contactListItems.importProgress.imported", { count: importProgress.imported })}</Paper></Grid>
            <Grid item xs={12} sm={4}>
              <Paper className={classes.statsCard}>
                <button
                  type="button"
                  className={classes.statsAction}
                  onClick={() => setShowExistingList(prev => !prev)}
                  disabled={!importProgress.existing}
                  style={{ color: importProgress.existing ? "#1d4ed8" : "inherit", cursor: importProgress.existing ? "pointer" : "default" }}
                >
                  {i18n.t("contactListItems.importProgress.existing", { count: importProgress.existing })}
                </button>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper className={classes.statsCard}>
                <button
                  type="button"
                  className={classes.statsAction}
                  onClick={() => setShowDuplicatedList(prev => !prev)}
                  disabled={!importProgress.duplicatedInsideSpreadsheet}
                  style={{ color: importProgress.duplicatedInsideSpreadsheet ? "#1d4ed8" : "inherit", cursor: importProgress.duplicatedInsideSpreadsheet ? "pointer" : "default" }}
                >
                  {i18n.t("contactListItems.importProgress.duplicated", { count: importProgress.duplicatedInsideSpreadsheet || 0 })}
                </button>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper className={classes.statsCard}>
                <button
                  type="button"
                  className={classes.statsAction}
                  onClick={() => setShowErrorList(prev => !prev)}
                  disabled={!importProgress.errors}
                  style={{ color: importProgress.errors ? "#b91c1c" : "inherit", cursor: importProgress.errors ? "pointer" : "default" }}
                >
                  {i18n.t("contactListItems.importProgress.errors", { count: importProgress.errors })}
                </button>
              </Paper>
            </Grid>
          </Grid>

          {showExistingList && (
            <div className={classes.detailsBox}>
              <strong style={{ display: "block", marginBottom: 6 }}>{i18n.t("contactListItems.importProgress.existingTitle")}</strong>
              {importProgress.existingContactsPreview?.length > 0 ? (
                <ul style={{ margin: 0, paddingLeft: 18 }}>
                  {importProgress.existingContactsPreview.map((item, index) => (
                    <li key={`${item.number || item.email || "existing"}-${index}`}>
                      {(item.name || i18n.t("common.noName"))} - {(item.number || "-")} - {(item.email || "-")}
                    </li>
                  ))}
                </ul>
              ) : (
                <p style={{ margin: 0 }}>{i18n.t("contactListItems.importProgress.noExistingDetails")}</p>
              )}
            </div>
          )}

          {showDuplicatedList && (
            <div className={classes.detailsBox}>
              <strong style={{ display: "block", marginBottom: 6 }}>{i18n.t("contactListItems.importProgress.duplicatedTitle")}</strong>
              {importProgress.duplicatedContactsPreview?.length > 0 ? (
                <ul style={{ margin: 0, paddingLeft: 18 }}>
                  {importProgress.duplicatedContactsPreview.map((item, index) => (
                    <li key={`${item.number || item.email || "dup"}-${index}`}>
                      {(item.name || i18n.t("common.noName"))} - {(item.number || "-")} - {(item.email || "-")}
                    </li>
                  ))}
                </ul>
              ) : (
                <p style={{ margin: 0 }}>{i18n.t("contactListItems.importProgress.noDuplicatedDetails")}</p>
              )}
            </div>
          )}

          {showErrorList && (
            <div className={classes.detailsBox}>
              <strong style={{ display: "block", marginBottom: 6 }}>{i18n.t("contactListItems.importProgress.errorTitle")}</strong>
              {importProgress.errorContactsPreview?.length > 0 ? (
                <ul style={{ margin: 0, paddingLeft: 18 }}>
                  {importProgress.errorContactsPreview.map((item, index) => (
                    <li key={`${item.number || item.email || "error"}-${index}`}>
                      {(item.name || i18n.t("common.noName"))} - {(item.number || "-")} - {(item.email || "-")} - {(item.reason || i18n.t("common.error"))}
                    </li>
                  ))}
                </ul>
              ) : (
                <p style={{ margin: 0 }}>{i18n.t("contactListItems.importProgress.noErrorDetails")}</p>
              )}
            </div>
          )}

          <Typography style={{ marginTop: 12, fontWeight: 500 }}>{importProgress.status}</Typography>
        </DialogContent>
        {importProgress.completed && (
          <DialogActions className={classes.importDialogActions}>
            <Button variant="contained" color="primary" onClick={() => setImportModalOpen(false)}>
              {i18n.t("common.buttons.close")}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </PageBase>
  );
};

export default ContactListItems;
